import React from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Modal } from "react-bootstrap";
import "./OurTeam.scss";
import { HTML5_FMT } from "moment";
import { getMainPageTeams } from "../../actions/AdminActions";
import { getImageUrl } from '../../helpers/helpers';

class Teams extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      teams: [],
      selected: false,
    };
    props.dispatch(getMainPageTeams(this.getTeamsData));
  }
  
  componentDidMount() {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
  }

  getTeamsData = (teams) => {
    if (teams) {
      this.setState({ teams });
    }
  };

  getText = (text) => {
    const { loadTranslations, currentLanguage } = this.props;
    return loadTranslations(text, currentLanguage);
  };

  getCard = (team) => {
    return (
      <Col lg={3} md={4} sm={6} xs={12}>
        <div className="teams-container teams-tile">
          <div className="team-avatar">
            <img src={getImageUrl(team.image)} alt="Avatar" class="image" />
          </div>
          <div className="text-center margin-top" style={{ minHeight: '60px' }}>
            <h4>{team.name}</h4>
            <h5 style={{ color: "#848484" }}>{team.title}</h5>
          </div>
          <div className="TeamOverlay">
            <div className="text">
              <Button
                onClick={() => this.setState({ open: true, selected: team })}
                className="emergency-bttn"
              >
                Vollständiges Profil anzeigen
              </Button>
            </div>
          </div>
        </div>
      </Col>
    );
  };

  render() {
    const { selected } = this.state;
    return (
      <div className="container paddingB50" style={{ paddingTop: '40px' }}>
        <section className="team-wrap relative">
          <div>
            <h1 className="titlenames">Unser Team</h1>
            <hr className="divider-hr" />
          </div>
          <Row className="teams-list-wrap">
            {this.state.teams.map((team) => {
              return this.getCard(team);
            })}
          </Row>
          <Modal
            dialogClassName="modal-60w custom-modal team-modal"
            show={this.state.open}
            onHide={() => this.setState({ open: false, selected: false })}
          >
            {selected && (
              <div className="padding">
                <Modal.Header closeButton>
                  {/* <Modal.Title
                    id="contained-modal-title-lg"
                    className="text-left full-width"
                  >
                    {selected.name}
                  </Modal.Title> */}
                </Modal.Header>
                <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <div className="teams-container">
                      <div className="team-avatar">
                        {/* <img src={selected.image} alt="Avatar" class="image" /> */}
                        <img src={getImageUrl(selected.image)} alt="Avatar" class="image" />
                      </div>
                    </div>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <div className="text-center">
                      <h1
                        style={{
                          textTransform: "uppercase",
                          letterSpacing: "2px",
                        }}
                      >
                        {selected.name}
                      </h1>
                      <h4
                        style={{
                          textTransform: "uppercase",
                          letterSpacing: "1px",
                          color: "rgb(132, 132, 132)",
                        }}
                      >
                        {selected.title}
                      </h4>
                    </div>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12} className="text-center">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `<h5>${selected.description}</h5>`,
                      }}
                    />
                    <hr className="divider-hr" />
                  </Col>
                  <Col
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ fontSize: "1.5rem" }}
                  >
                    <div className="text-center margin-vertical">
                      <h4
                        style={{
                          textTransform: "uppercase",
                          paddingBottom: "2px",
                          borderBottom: "1px dashed #ededed",
                          display: "inline-block",
                        }}
                      >
                        {selected.category}
                        Ausbildung
                      </h4>
                    </div>
                    <ul className="education-details">
                      {selected &&
                        selected.trainings.map((val) => {
                          return (
                            <React.Fragment>
                              <li>
                                <h4 style={{ color: "#848484" }}>
                                  {val.period}
                                </h4>
                                <h5>{val.message}</h5>
                               
                              </li>
                            </React.Fragment>
                          );
                          // <Row>
                          //   <Col lg={4} md={4} sm={4} xs={12}>
                          //     <div style={{ padding: '5px 0' }}>{val.period}</div>
                          //   </Col>
                          //   <Col lg={8} md={8} sm={8} xs={12}>
                          //     <div style={{ padding: '5px 0' }}>{val.message}</div>
                          //   </Col>
                          // </Row>
                        })}
                    </ul>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <Modal.Footer>
                      <Button
                        onClick={() =>
                          this.setState({ open: false }, () =>
                            this.setState({ selected: false })
                          )
                        }
                        className="emergency-bttn"
                      >
                        Schliessen
                      </Button>
                    </Modal.Footer>
                    {/* <center><Button onClick={() => this.setState({ open: false }, () => this.setState({ selected: false }))} className="emergency-bttn">CLOSE</Button></center> */}
                  </Col>
                </Row>
              </div>
            )}
          </Modal>
          {this.state.teams.length > 0 ? (
            <div className="margin-top text-center">
              <Button
                onClick={() => this.props.router.push("/ourTeam")}
                className="emergency-bttn"
              >
               Vollständiges Team anzeigen
              </Button>
            </div>
          ) : (
              <div className="no-team-available text-center"><h5> <i className="fas fa-exclamation-triangle" /> No Teams Available</h5></div>
            )}
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.users.currentLanguage,
  };
}

export default connect(mapStateToProps)(Teams);



// WEBPACK FOOTER //
// ./screens/OurTeam/Teams.js